import React from "react";
import "./daterangepicker.scss";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";


// interface to declare all our prop types
interface Props {
    defaultShow?: boolean;
    disabled?: boolean;
    defaultValue?: any;
    onChange?: any;
    validationMessage?:string;
    required?:any;
    value?:any;
    min?: any;
    onBlur?: any;
}

const DatepickerDefault: React.FC<Props> = ({
    defaultShow,
    disabled,
    defaultValue,
    value,
    validationMessage,
    required,
    min,
    onChange,
    onBlur,
  ...rest
}) => {
  return (
    <div className="daterangepicker">
        <DateRangePicker format="dd/MM/yyyy" 
        defaultShow={defaultShow} 
        min={min}
        defaultValue={defaultValue} 
        disabled={disabled}
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        />
    </div>
  );
};

export default DatepickerDefault;


